<template>
<div id="sheet-add-view">
  <div v-if="showSpiadiAlert">
    <alert type="warning">
      <p>
        <strong>
          Vos données ont déjà été envoyées au programme national.
        </strong>
      </p>
      <p class="text-justify">
        Si vous ajoutez, supprimez ou modifiez une fiche correspondant à la
        période de surveillance, n'oubliez pas de mettre à jour les fiches
        en utilisant le bouton <strong>«Clôture {{dataset}}»</strong> sur la
        page d'accueil de la modalité.
      </p>
    </alert>
  </div>
  <sheet-add :config="config"
             :state="state"
             :sheets="sheets"
             :surveillance="surveillance"
             :sid="sid"
             :type="type"
             :year="year"
             :saveReminderTimer="saveReminderTimer"
             ref="add"></sheet-add>
</div>
</template>
<script>
import add from '@/sui/components/sheet/add/add'
import { mapState } from 'vuex'

export default {
  name: 'sheet-add-view',
  props: {
    config: {
      type: Object,
      required: true
    },

    sheets: {
      type: Array,
      required: true
    },

    state: {
      type: Object,
      required: true
    },

    surveillance: {
      type: Object,
      required: true
    }
  },

  methods: {
    checkRoute: function (to, from, next) {
      this.$refs.add.checkRoute(to, from, next)
    },

    refresh: function () {
      this.$refs.add.selectFirstStep()
    },

    save: function () {
      this.$refs.add.save()
    }
  },

  computed: {
    ...mapState({
      options: state => state.cloud.cfg.options
    }),

    showSpiadiAlert: function () {
      const mod = this.surveillance.modules[this.type]
      if (mod == null || mod.dset == null) {
        return false
      }
      const dset = mod.dset.find(d => d.name === this.dataset)
      if (dset == null) {
        return false
      }

      return dset.step >= 2
    },

    dataset: function () {
      return `SPIADI${this.surveillance.year}`
    },

    year: function () {
      return `${this.surveillance.year}`
    },

    type: function () {
      return this.$route.params.st
    },

    saveReminderTimer: function () {
      return this.type === 'badiCause' ? this.options.badiCauseTimer : null
    },

    sid: function () {
      return this.$route.params.sid
    }
  },

  components: {
    'sheet-add': add
  }
}
</script>
<style scoped lang="less">
</style>
